"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PIMTokenServiceConfig = exports.PIMTokenEndpoint = exports.PIMSettingsServiceEndpoint = void 0;

var _PIMToken = _interopRequireDefault(require("../models/PIMToken"));

var _serviceEndpoints = _interopRequireDefault(require("../constants/service-endpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var axios = require("axios")["default"];
/**
 * @type {PIMToken}
 */


var cachedServicesTokens = {};
var axiosPromise = null;

var getLanguageFromHTML = function getLanguageFromHTML() {
  return document.querySelector("html").getAttribute("lang") || "";
};

var PIMSettingsServiceEndpoint = "/webservices/productexperience.svc/getpimsettingscatalogid/";
exports.PIMSettingsServiceEndpoint = PIMSettingsServiceEndpoint;
var PIMTokenEndpoint = "/webservices/pim.svc/getaccesstoken";
exports.PIMTokenEndpoint = PIMTokenEndpoint;
var PIMTokenServiceConfig = {
  url: PIMTokenEndpoint,
  decorateRequest: function decorateRequest(url) {
    return url;
  }
};
/**
 * @type {PIMTokenService}
 * @private
 */

exports.PIMTokenServiceConfig = PIMTokenServiceConfig;
var instance = null;

var PIMTokenService =
/*#__PURE__*/
function () {
  function PIMTokenService() {
    _classCallCheck(this, PIMTokenService);
  }

  _createClass(PIMTokenService, [{
    key: "getTokenForService",
    value: function getTokenForService(serviceName, forceTokenFromServer) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (!serviceName) {
          reject(new Error("Missing service name"));
        }

        if (!(0, _serviceEndpoints["default"])(serviceName)) {
          reject(new Error("Unknown service name"));
        }

        var cachedToken = !forceTokenFromServer ? _this.getCachedTokenForService(serviceName) : false;

        if (cachedToken && _this.isNotExpired(cachedToken)) {
          resolve(cachedToken);
        } else {
          _this.retrieveTokenFromServer({
            language: getLanguageFromHTML(),
            authenticationPath: (0, _serviceEndpoints["default"])(serviceName).TOKEN,
            serviceReference: serviceName
          }).then(function (token) {
            if (token) {
              _this.setCachedTokenForService(serviceName, token);

              resolve(token);
            } else {
              reject(_this.createResponseError());
            }
          })["catch"](function (error) {
            _this.setCachedTokenForService(serviceName, null);

            reject(error);
          });
        }
      });
    }
  }, {
    key: "getCulture",
    value: function getCulture() {
      var _this2 = this;

      var htmlCulture = document.querySelector(".component[data-culture]");

      if (htmlCulture) {
        return new Promise(function (resolve) {
          resolve(htmlCulture.getAttribute("data-culture"));
        });
      } else {
        return axios.get("".concat(PIMSettingsServiceEndpoint).concat(getLanguageFromHTML())).then(function (response) {
          if (response && response.data) {
            return response.data;
          }

          throw _this2.createResponseError();
        })["catch"](function (error) {
          if (error.response) {
            throw _this2.createResponseError();
          } else if (error.request) {
            throw _this2.createResponseError();
          } else {
            throw error;
          }
        });
      }
    }
  }, {
    key: "getCatalogID",
    value: function getCatalogID() {
      var _this3 = this;

      var componentWithCatalog = document.querySelector(".component[data-catalogid]");

      if (componentWithCatalog) {
        return new Promise(function (resolve) {
          var htmlCatalogId = componentWithCatalog.getAttribute("data-catalogid");
          resolve(htmlCatalogId);
        });
      } else {
        return axios.get("".concat(PIMSettingsServiceEndpoint).concat(getLanguageFromHTML())).then(function (response) {
          if (response && response.data) {
            return response.data;
          }

          throw _this3.createResponseError();
        })["catch"](function (error) {
          if (error.response) {
            throw _this3.createResponseError();
          } else if (error.request) {
            throw _this3.createResponseError();
          } else {
            throw error;
          }
        });
      }
    }
  }, {
    key: "getCatalogStatus",
    value: function getCatalogStatus() {
      var _this4 = this;

      var componentWithCatalog = document.querySelector(".component[data-catalog-status]");

      if (componentWithCatalog) {
        return new Promise(function (resolve) {
          var htmlCatalogStatus = componentWithCatalog.getAttribute("data-catalog-status");
          resolve(htmlCatalogStatus);
        });
      } else {
        return axios.get("".concat(PIMSettingsServiceEndpoint).concat(getLanguageFromHTML())).then(function (response) {
          if (response && response.data) {
            return response.data;
          }

          throw _this4.createResponseError();
        })["catch"](function (error) {
          if (error.response) {
            throw _this4.createResponseError();
          } else if (error.request) {
            throw _this4.createResponseError();
          } else {
            throw error;
          }
        });
      }
    }
    /**
     * @private
     * @param {string} serviceName
     * @returns {string|null}
     */

  }, {
    key: "getCachedTokenForService",
    value: function getCachedTokenForService(serviceName) {
      return cachedServicesTokens[serviceName];
    }
    /**
     * @private
     * @param {PIMToken} token
     * @returns {boolean}
     */

  }, {
    key: "isNotExpired",
    value: function isNotExpired(token) {
      return new Date() < token.expireDate;
    }
    /**
     * @param {Object<string,string>|null} params
     * @private
     * @returns {Promise.<PIMToken|Error>}
     */

  }, {
    key: "retrieveTokenFromServer",
    value: function retrieveTokenFromServer(params) {
      var _this5 = this;

      if (!axiosPromise) {
        axiosPromise = axios.get(this.resolveURL(params), {
          params: params
        }).then(function (response) {
          if (response && response.data) {
            axiosPromise = null;
            return _PIMToken["default"].fromJSON(response.data);
          }

          axiosPromise = null;
          throw _this5.createResponseError();
        })["catch"](function (error) {
          if (error.response) {
            axiosPromise = null;
            throw _this5.createResponseError();
          } else if (error.request) {
            axiosPromise = null;
            throw _this5.createResponseError();
          } else {
            axiosPromise = null;
            throw error;
          }
        });
      }

      return axiosPromise;
    }
    /**
     * @param {string|null} tokenEndpoint
     */

  }, {
    key: "resolveURL",
    value: function resolveURL(params) {
      if (PIMTokenServiceConfig.decorateRequest) {
        return PIMTokenServiceConfig.decorateRequest(PIMTokenServiceConfig.url, params);
      }

      return PIMTokenServiceConfig.url;
    }
  }, {
    key: "setCachedTokenForService",
    value: function setCachedTokenForService(serviceName, token) {
      cachedServicesTokens[serviceName] = token;
    }
    /**
     * @private
     */

  }, {
    key: "createResponseError",
    value: function createResponseError() {
      return new Error("Failed to retrieve token from ".concat(this.resolveURL()));
    }
  }, {
    key: "flushToken",
    value: function flushToken() {
      cachedServicesTokens = {};
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!instance) {
        instance = new PIMTokenService();
      }

      return instance;
    }
  }]);

  return PIMTokenService;
}();

var _default = PIMTokenService;
exports["default"] = _default;